export const UploadContextType = {
    CONTRACT: "contract",
    PROPERTY: "property",
    USER: "user",
    OWNER_DOCUMENT: "owner_document",
};
